//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { FactoryUtils } from "@/utils/FactoryUtils"   
import Inform from '@/components/layer/inform.vue';

import identity from './components/identity'
import Commodity  from './components/commodity'
import { creatOrder } from '@/model/trader/orderService'
import { store } from '@/observable/store'

import { getChannelGoods, electronicCode } from '@/model/stencil/shop'
import { Share } from '@/utils/commonUtils'
import { paySystem,payIsWeixin } from '@/utils/pay/parameter'
import { Parameter } from '@/utils/orderParme'
import userInfoToast from '@/components/toast/userInfo'

import Txrweb from '@/utils/mixin/mixinTxrweb'
import clearKeepAlive from '@/utils/mixin/mixinCache'
import InsuranceReview from '@/utils/mixin/InsuranceReview'

export default {
    name: "stencilShop",
    mixins:[clearKeepAlive,Txrweb,InsuranceReview],
    data(){
        return {
            templateFlag:'',
            modify_mark:'', // 皮肤
            shopType:null, //商品类型 1 保险商品 2 电子码商品 
            title:'',
            // 商品内容 
            home_image:'', // 首屏
            home_button:'', // 首屏按钮
            homeImage_gif:'', //首屏动图
            service_image:'', // 服务
            service_btn:'',
            organization_image:'', // 机构
            organization_btn:'',
            procedure_image:'', // 流程
            telStr:'',
            tel:'',
            submit_button:'', // 提交按钮
            identityTitle:'',//投保模块title
            identityTitleDec:'',//title描述
            identityBackimg:'',
            economicImg:'',  //经济公司配图
            share_title:'',
            share_content:'',
            share_image:'',
            share_friend_content:'',
            amountPrice :null, //实付
            payable_amount :null, //应付
            policy_id:'0'// 加密数据id
        }
    },
    components:{
      Commodity,
      identity,
      Inform,
      userInfoToast,
    },
    computed: {
        uid(){
            return store.uid
        },
        syToken(){
            return store.syToken
        },
        loginPhone(){
            return store.phone
        },
        
        handleNameLen(playerName, len){
            return (playerName, len)=>{
                var new_playerName = "";
                if (playerName.length > len) {
                    new_playerName = playerName.substring(0, len-1);
                    new_playerName += "..."
                }
                else {
                    new_playerName = playerName;
                }
                return new_playerName;
            }

        }
    },
    watch:{
        share_title(){
            this.share_info()
        }
    },
    activated(){
        // console.log(this.title)
        document.title = this.title;
    },
    created() {
      this.templateFlag = this.$route.query.templateFlag
      this.modify_mark = this.$route.query.modify_mark

      // 获取商品信息
      this.getInfo()
    },
    mounted() {
        this.STATISTICS_CONFIG.insur_proinfo_page()
    },
    methods:{
        // 分享信息 
        share_info(){
            let obj = {
                'shareContent':this.share_content,
                'shareTimelineContent': this.share_title,
                'shareImgurl':  this.share_image,
                'shareTitle':  this.share_title,
                'shareUrl': `${window.location.href}`,
                'rightBtnStatus': 1
                }
            let objCircle ={
                'shareTitle':this.share_friend_content,
                'shareContent': this.share_friend_content,
                'shareUrl':  `${window.location.href}`,
                'shareImgurl': this.share_image,
                'rightBtnStatus': 1
                }
            document.title = this.title;
            Share(obj,'sybao_ins_product_share_result_sys',objCircle)
        },
        creadInfo(){
            if(this.shopType == 1){
                let top = document.getElementById('infoId').offsetTop
                setTimeout(function(){
                    scrollTo(0,top)
                },100)
                this.$refs.identityRef.creadInfo()
            }if(this.shopType == 2){
                if(this.uid == 0){
                    this.$refs.showLogin.showoast()
                }else{
                    this.identityInfo()
                }
            }
        },
        // 获取商品信息
        getInfo(){
            getChannelGoods(this.templateFlag,this.modify_mark).then(data=>{
                this.shopType = data.type;
                if(data.stencil){
                    this.title = this.handleNameLen(data.stencil.page_title,10)
                }
                this.amountPrice = data.receipts_amount //实付
                this.payable_amount = data.payable_amount //应付

                const stencil = data.stencil
                // 投保模块
                this.identityTitle = stencil.insure_info.title ;//投保模块title
                this.identityTitleDec = stencil.insure_info.detail_content ; //title描述
                this.identityBackimg = stencil.insure_info.background ; //投保模块背景图
                this.submit_button = stencil.button_info.bottom_button // 提交按钮

                // 首屏
                this.home_image = stencil.product_info.detail_image // 首屏
                this.home_button = stencil.product_info.submit_button // 首屏按钮
                this.homeImage_gif = stencil.product_info.dynamic_image //首屏gif

                // 服务
                this.service_image = stencil.service_info.detail_image;
                this.service_btn = stencil.service_info.detail_button;

                // 机构
                this.organization_image = stencil.organization_info.detail_image 
                this.organization_btn = stencil.organization_info.detail_button  //机构按钮
                // 流程
                this.procedure_image = stencil.introduction_info.detail_image 
                this.telStr = stencil.introduction_info.customer_content;
                this.tel = stencil.introduction_info.customer_phone;

                // 经济公司
                this.economicImg = stencil.agency.background;

                // 上次投保人信息
                data.last_identity_info.insure_name ? this.bus.$emit("nameInputFlag",data.last_identity_info.insure_name): ''
                data.last_identity_info.insure_idcard ? this.bus.$emit("idCardInputFlag",data.last_identity_info.insure_idcard): ''
                data.last_identity_info.insure_phone ? this.bus.$emit("phoneInputFlag",data.last_identity_info.insure_phone): ''
                
                // 分享内容
                this.share_title = data.share.share_friend
                this.share_content = data.share.share_content
                this.share_image = data.share.share_image
                this.share_friend_content = data.share.share_timeline

                this.policy_id = data.last_identity_info.policy_id
            })
        },
        // 创建订单 
        identityInfo(msg){
            if(this.shopType == 1){
                this.insurance(msg)
            }else if(this.shopType == 2){
                this.coupon()
            }
        },
        insurance(msg){ //保险
            let parmer = {
                modify: this.modify_mark,
                channel_good: this.modify_mark,
                applicant:{  //投保人对象
                    phone:msg.phone,//手机号
                    name:msg.name,//姓名
                    idcard:msg.idcard//身份证号码
                },
                template:this.templateFlag, // 接口名
                amount:this.amountPrice/100, //实付金额
                payable_amount:this.payable_amount/100, //应付金额 
                traceback:store.TXoption.bizKey,
                last_policy_id:this.policy_id || 0
            }
            const parameter = Parameter(parmer)
            //核保   
            this.insuranceToReview(parameter,'creatOrder')
            // creatOrder(parameter).then(data=>{
            //     // 更新可回溯信息
            //     this.updataTX(parameter.applicant, data.out_trade_no)

            //     this.STATISTICS('click','sybao_ins_proinfo_pay_cashier_click')
            //     if(this.amountPrice != 0 ){
            //         this.$router.push({
            //             path: "/pay",
            //             query:{
            //                 outTrade:data.out_trade_no,
            //                 uuid:data.uuid,
            //                 paySuccessSate:'activation'
            //             }
            //         });
            //     }else{
            //         this.toSuccess()
            //     }  
            // }).catch(err=>{
            //     this.$toast(err.message); 
            // })
        },
        coupon(){ //卡券(不需要核保)
            let parmer = {
                "channel_good": this.modify_mark,
                "amount": this.amountPrice,
                "payable_amount": this.payable_amount,
                "is_weixin": payIsWeixin(),
                "system": paySystem(),
                "trade_type": "paid",
            }
            electronicCode(parmer).then(data =>{
                if(data.redirect_info && data.redirect_info.need_redirect && data.redirect_info.redirect_url){
                    // 支付
                    window.location.href= data.redirect_info.redirect_url
                }else{
                    this.toSuccess()
                }
            }).catch(err=>{
                this.$toast(err.message);
            })
        },
        // 领取成功
        toSuccess(){
            this.$router.push({
                path: "/happySuccess",
                query:{
                    templateFlag:this.templateFlag
                }
            });
        }

    }
}
